// Color token mappings to Tailwind classes
export const COLOR_TOKEN_CLASSES: Record<string, string> = {
  primary: "bg-blue-50 text-blue-700",
  success: "bg-green-50 text-green-700",
  danger: "bg-red-50 text-red-700",
  warning: "bg-yellow-50 text-yellow-700",
  info: "bg-cyan-50 text-cyan-700",
  neutral: "bg-gray-100 text-gray-700",
  purple: "bg-purple-100 text-purple-700",
  rose: "bg-pink-100 text-pink-700",
};
